import { ChevronDown } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/shared/components/ui/popover'
import { AGENTS, FEATURED_AGENT } from '@/features/agents/data/agents-dashboard-data'
import { useAssistantStore } from '../store/assistant-store'
import type { AgentId } from '../types/assistant'

const ALL_AGENTS = [FEATURED_AGENT, ...AGENTS]

interface Props {
  currentAgentId: AgentId
  agentName: string
}

export function AgentSwitcherDropdown({ currentAgentId, agentName }: Props) {
  const { switchAgent } = useAssistantStore()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-0.5 hover:underline text-sm font-semibold leading-none">
          {agentName}
          <span className="text-xs font-normal text-muted-foreground ml-0.5">(AI)</span>
          <ChevronDown className="h-3 w-3 text-muted-foreground ml-0.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-1.5" align="start" side="bottom">
        <p className="text-[10px] text-muted-foreground px-2 py-1 font-medium uppercase tracking-wide">
          Switch Agent
        </p>
        <div className="space-y-0.5 max-h-72 overflow-y-auto">
          {ALL_AGENTS.map((agent) => {
            const isActive = agent.id === currentAgentId
            return (
              <button
                key={agent.id}
                className={cn(
                  'flex items-center gap-2 w-full rounded-md px-2 py-1.5 text-left hover:bg-muted transition-colors',
                  isActive && 'bg-muted',
                )}
                onClick={() => switchAgent(agent.id as AgentId)}
              >
                <div
                  className={cn(
                    'h-6 w-6 rounded-full flex items-center justify-center text-white text-[8px] font-bold shrink-0',
                    agent.avatarColor,
                  )}
                >
                  {agent.avatarInitials}
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-medium leading-none truncate">{agent.name}</p>
                  <p className="text-[10px] text-muted-foreground truncate mt-0.5">{agent.role}</p>
                </div>
                {isActive && (
                  <span className="ml-auto h-1.5 w-1.5 rounded-full bg-green-500 shrink-0" />
                )}
              </button>
            )
          })}
        </div>
      </PopoverContent>
    </Popover>
  )
}
